<ng-container
  *ngIf="{
    mapIsShown: mapIsShown$ | async,
    shops: shopsSorted$ | async,
    activeId: activeId$ | async,
    activeShop: activeShop$ | async,
  } as obs"
>
  <h4>Адреса самовывоза</h4>
  <div class="map-wrapper">
    <div class="address-form-buttons">
      <button (click)="toggle()" class="btn btn-map btn-default btn-link btn-sm">
        <cx-icon class="icon" [type]="iconType.POINT"></cx-icon>
        {{ obs.mapIsShown ? 'Скрыть карту' : 'Найти на карте' }}
      </button>
    </div>

    <div *ngIf="!obs.mapIsShown">
      <ui-address-suggestions-select
        placeholder="ближайший к вам адрес"
        (changeAddress)="onChangeAddress($event)"
      ></ui-address-suggestions-select>
    </div>

    <div [ngClass]="{ hide: obs.mapIsShown }" #shopListRef class="shoplist">
      <div
        *ngFor="let shop of obs.shops"
        id="id{{ shop.name }}"
        (click)="clickToListShop(shop.name, DEFAULT_ZOOM)"
        [ngClass]="{ active: shop.name === obs.activeId }"
        class="shop"
      >
        <div *ngIf="shop.expressPicking" class="shop-express">Экспресс комплектация</div>
        <div class="shop-address">
          {{ shop.addressFormatted }}
          <div *ngIf="shop.name">{{ shop.displayName }}</div>
        </div>

        <div class="shop-worktime">
          <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
        </div>
        <div
          *ngIf="
            shop.pickupDate && (shop.pickupDate | uiTodayTomorrowDate: 'd MMMM') as pickupDate;
            else pickupDateEmpty
          "
          class="shop-delivery-date"
        >
          Можно забрать
          <span [class]="pickupDate === 'сегодня' ? 'available' : 'not-available'">
            {{ pickupDate }}
          </span>
        </div>
      </div>

      <ng-template #pickupDateEmpty>
        <div class="shop-delivery-date">Дату самовывоза уточнит оператор</div>
      </ng-template>
    </div>
    <div [ngClass]="{ hide: !obs.mapIsShown }">
      <sd-shops-map
        *ngIf="environmentService.isPlatformBrowser"
        [shops]="shopList"
        [activeShopId]="obs.activeId"
        class="map-pickup"
        [showBalloon]="false"
        (created)="onMapCreated($event)"
        (placemarkShopClick)="clickToListShop($event)"
      ></sd-shops-map>
    </div>
  </div>

  <div *ngIf="obs.activeShop as shop" class="bottom-fixed-shop" [ngClass]="{ hide: !obs.mapIsShown }">
    <button type="button" aria-label="Close" tabindex="-1" class="btn-close" (click)="resetActive()"></button>
    <div class="pickup-shop-list-mobile-placemark">
      <div class="shop-address">{{ shop.addressFormatted }}</div>
      <div class="shop-worktime">
        <sd-shop-working-time [shop]="shop"></sd-shop-working-time>
      </div>

      <div
        *ngIf="shop.pickupDate && (shop.pickupDate | uiTodayTomorrowDate: 'd MMMM') as pickupDate; else pickupDateEmpty"
        class="shop-delivery-date"
      >
        Можно забрать
        <span [class]="pickupDate === 'сегодня' ? 'available' : 'not-available'">
          {{ pickupDate }}
        </span>
      </div>

      <ng-template #pickupDateEmpty>
        <div class="shop-delivery-date">Дату самовывоза уточнит оператор</div>
      </ng-template>

      <p>
        <button type="button" class="btn btn-primary w-100 btn-change" (click)="confirmShop(shop.name)">Выбрать</button>
      </p>
    </div>
  </div>
</ng-container>

<ng-template #pickupDateEmpty>
  <div class="shop-delivery-date">Дату самовывоза уточнит оператор</div>
</ng-template>
